import angular from 'angular';
import importantDocumentsTable from './importantDocumentsTable';
import uploadDocumentButton from './uploadDocumentButton';

export default angular
  .module('importantDocuments.scenes.components', [])
  .component('uploadDocumentButton', uploadDocumentButton)
  .component('importantDocumentsTable', importantDocumentsTable).name;
